import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  return {
    LoadMoreResultsBtnCont: isMapPage => css`
      width: 100%;
      margin: ${isMapPage ? '0' : '2.5rem 0 0 0'};
    `,
    LoadMoreResultsBtn: css`
      display: flex;
      background: ${colors.white};
      text-decoration: none;
      cursor: pointer;
      padding: 0.75rem;
      outline: none;
      border: 2px solid ${colors.border_blue};
      border-radius: 4px;
      font-family: FS Dillon;
      font-size: 1rem;
      letter-spacing: 0.015rem;
      line-height: 1.25rem;
      font-weight: 500;
      width: 100%;
      align-items: center;
      justify-content: center;
      text-align: center;
      text-transform: uppercase;
      gap: 4px;
      color: ${colors.placeholder_black2};
      transition: all 0.3s ease;
      @media (hover: hover) and (pointer: fine) {
        &:hover,
        &:focus {
          color: ${colors.navy};
          border: 2px solid ${colors.navy};
          background-color: ${colors.pale_blue};
        }
      }
      &:active {
        color: ${colors.navy};
        border: 2px solid ${colors.navy};
        background-color: ${colors.pale_blue};
      }
      &:focus-visible:not(:hover) {
        outline: none;
        background-color: ${colors.skip_yellow};
        border: 2px solid ${colors.border_black};
        color: ${colors.border_black};
        text-decoration: underline;
      }
      ${breakpoints.mm_m_l} {
        font-size: 1rem;
        line-height: 1.25rem;
        letter-spacing: 0.015rem;
      }
      ${breakpoints.mm_s_m} {
        font-size: 1rem;
        line-height: 1.25rem;
        letter-spacing: 0.015rem;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 1rem;
        line-height: 1.25rem;
        letter-spacing: 0.015rem;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 1rem;
        line-height: 1.25rem;
        letter-spacing: 0.015rem;
      }
    `,
  };
};
